export enum TemplateMail {       
     ForgotPassword=5,     
     ChangePassword=6,     
}